import { render, staticRenderFns } from "./tokushoho.vue?vue&type=template&id=04002aa9&scoped=true&lang=pug&"
import script from "./tokushoho.vue?vue&type=script&lang=js&"
export * from "./tokushoho.vue?vue&type=script&lang=js&"
import style0 from "./Tokushoho.scss?vue&type=style&index=0&id=04002aa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04002aa9",
  null
  
)

export default component.exports